<script lang="ts" setup>
import 'vue3-carousel/dist/carousel.css'
import { Carousel } from 'vue3-carousel'

const { fetchCoins } = useCoins()
const { tokens } = storeToRefs(useCoins())

const breakpoints = {
  // 0px and up
  0: {
    itemsToShow: 2,
    snapAlign: 'start',
  },
  // 700px and up
  700: {
    itemsToShow: 4,
    snapAlign: 'start',
  },
  // 1024 and up
  1024: {
    itemsToShow: 5,
    snapAlign: 'start',
  },
  // 1280 and up
  1280: {
    itemsToShow: 7,
    snapAlign: 'start',
  },
}

onMounted (() => {
  fetchCoins()
})
</script>

<template>
  <ClientOnly>
    <Carousel :wrap-around="true" :autoplay="1500" :transition="500" :pause-autoplay-on-hover="true" :breakpoints="breakpoints" w-full cursor-grab>
      <Slide v-for="token in tokens" :key="token.name" h-100px>
        <div px-8px w-full h-full>
          <div
            flex items-center justify-center
            w-full h-full
          >
            <NuxtImg :src="`/img/coins/${token.code}.svg`" :alt="token.name" w-32px inline mr-16px />
            <div flex flex-col items-start>
              <div paragraph-xs font-600 leading-snug>
                {{ token.name }}
              </div>
              <div paragraph-xs leading-snug>
                {{ formatPriceInCzk(token.showingPrice) }} <span v-if="token.change24HPercent" :class="token.change24HPercent < 0 ? 'text-coingecko-red' : 'text-coingecko-green'">{{ formatPercentChange(token.change24HPercent) }}</span>
              </div>
            </div>
          </div>
        </div>
      </Slide>
    </Carousel>
  </ClientOnly>
</template>
